import { GlobalDocumentTemplateRes, TemplateAvailability } from '@dealstack/shared/lib/generated';
import { StatusBadge } from '@dealstack/frontend/shared/components/StatusBadge/StatusBadge';
import { availabilityLabel } from '@dealstack/frontend/app/pages/DocumentTemplates/TemplateAvailability/availabilityLabel';

interface Props {
	template: GlobalDocumentTemplateRes;
}

export const AvailabilityCell = ({ template }: Props) => {
	const { availability, dealCount } = template;
	// Teal reads as "reachable", grey as "reaches nothing" — the count alone can't say that,
	// since ALL_DEALS keeps a preserved selection.
	const isAvailable = availability === TemplateAvailability.ALL_DEALS || dealCount > 0;
	const color = isAvailable ? 'teal.8' : 'gray.6';

	return (
		<StatusBadge
			text={availabilityLabel(availability, dealCount)}
			color={color}
			textColor={color}
		/>
	);
};
